import userStorage from 'src/modules/authentication/storage/user/storage';
import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import AnswerAPIs from '../../db/answer';
import EFAPIs from '../../db/examiners-feedback';
import NodeUserInfoAPIs from '../../db/node-user-info';
import QPAPIs from '../../db/question-paper';
import QuestionAPIs from '../../db/question/index';
import { mapQPToNode } from '../40-question-paper/utils';
import { EPNodeFieldsResolvers } from '../5-node/fields';
import { mapAnswerToNode } from '../60-answer/utils';
import { mapEFToNode } from '../70-examiner-feedback/utils';
import { mapQuestionToNode } from './utils';
const EPQuestionNodeFieldsResolvers = {
    async userData(node, context) {
        const userID = userStorage.getUserDetails().id;
        const questionUserData = await NodeUserInfoAPIs.getUserData(userID ?? getCurrentUserID(), node.id);
        return {
            read: questionUserData?.read ?? false,
            bookmarked: questionUserData?.bookmarked ?? false,
        };
    },
    async duplicates(node, context) {
        const result = await QuestionAPIs.getDuplicates(getCurrentUserID(), node);
        return result.map(mapQuestionToNode);
    },
    async questionPaper(node, context) {
        const result = await QPAPIs.getForQuestion(getCurrentUserID(), node.id);
        return mapQPToNode(result);
    },
    async answer(node, context) {
        const result = await AnswerAPIs.getForQuestion(getCurrentUserID(), node.id);
        return result ? mapAnswerToNode(result) : null;
    },
    async examinersFeedback(node, context) {
        const result = await EFAPIs.getForQuestion(getCurrentUserID(), node.id);
        return result ? mapEFToNode(result) : null;
    },
};
export const epQuestionFieldsResolvers = {
    EPQuestion: {
        ...EPNodeFieldsResolvers,
        ...EPQuestionNodeFieldsResolvers,
    },
    // EPQuestionData: EPQuestionDataNodeFieldsResolvers,
};
